import { PageHero, SectionHeading, CTABand } from "../components/shared";
import { Reveal } from "../components/Reveal";
import { SECTORS, IMAGES } from "../data/content";

const DETAIL = {
  "Mobile Network Operators": { challenge: "Fast rollout and sustained uptime across large, dispersed networks.", benefit: "Coordinated field crews and SLA-based maintenance." },
  "Telecom OEMs": { challenge: "Reliable field execution capacity for equipment programmes.", benefit: "Trained installation and commissioning teams." },
  "Tower Infrastructure Companies": { challenge: "Portfolio-wide site works and preventive maintenance.", benefit: "Multi-site managed field teams." },
  "Internet Service Providers": { challenge: "Backhaul, fibre and last-mile deployment at pace.", benefit: "OFC survey, laying, splicing and testing support." },
  "Enterprise Networks": { challenge: "Campus connectivity, structured cabling and works.", benefit: "Turn-key infrastructure execution." },
  "Fibre & Broadband Providers": { challenge: "Route surveys, restoration and fault localisation.", benefit: "OTDR testing and documented route mapping." },
  "Government Infrastructure": { challenge: "Public-sector connectivity and compliance.", benefit: "Disciplined delivery with full documentation." },
  "Engineering & EPC Contractors": { challenge: "Specialist telecom resource on demand.", benefit: "Flexible, mobilisable technical capacity." },
};

const Industries = () => (
  <>
    <PageHero overline="Industries" title="Who We Work With" subtitle="Airanet supports a broad set of telecom and infrastructure clients — from operators and OEMs to government programmes and EPC contractors." image={IMAGES.noc} />
    <section className="py-24 bg-white">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8">
        <SectionHeading overline="Customer Segments" title="Sectors We Support" />
        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {SECTORS.map((s, i) => {
            const d = DETAIL[s.t] || {};
            return (
              <Reveal key={s.t} delay={(i % 2) * 0.08}>
                <div className="h-full bg-[#F4F6F8] border border-[#E2E8F0] rounded-lg p-7 hover-lift hover:border-[#1EA7E1]">
                  <div className="flex items-center gap-3">
                    <span className="font-mono2 text-sm text-[#1261A0]">{String(i + 1).padStart(2, "0")}</span>
                    <h3 className="font-head font-semibold text-xl text-[#0B1F3A]">{s.t}</h3>
                  </div>
                  <p className="mt-4 text-[#64748B]">{s.d}</p>
                  <div className="mt-5 grid sm:grid-cols-2 gap-4">
                    <div><p className="text-xs uppercase tracking-wide font-semibold text-[#F28C28]">Typical Challenge</p><p className="mt-1 text-sm text-[#252B33]">{d.challenge}</p></div>
                    <div><p className="text-xs uppercase tracking-wide font-semibold text-[#1261A0]">Delivery Benefit</p><p className="mt-1 text-sm text-[#252B33]">{d.benefit}</p></div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
        <p className="mt-10 text-sm text-[#64748B] italic">Customer logos are not displayed without written approval.</p>
      </div>
    </section>
    <CTABand />
  </>
);

export default Industries;
